
<template>
  <b-container fluid="md" class="my-5">
    <action-widget />
    <router-view />
  </b-container>
</template>

<script>
  import ActionWidget from "@c/ActionWidget.vue";
  export default {
    name: "PublicFormulars",
    components: {
      ActionWidget,
    },
  };
</script>

<style>
</style>
